export default class BookingSystem {
  type;
}